import {CheckCircleOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {useState} from 'react';

const GoldForm = () => {
  const [form] = Form.useForm();

  const [isSubmitted, setIsSubmitted] = useState(false);

  const onFinish = () => {
    setIsSubmitted(true);
  };

  const {TextArea} = Input;

  return (
    <div className={'flex flex-col justify-center items-center p-4 lg:px-20 mt-5 w-full'}>
      <h1 className={'text-2xl font-serif-custom text-primary-900'}>Contact Us</h1>
      <div>
        {isSubmitted ? (
          <div className={'flex flex-col items-center mt-2 font-semibold lg:text-lg'}>
            <CheckCircleOutlined className={'font-semibold'} />
            <div>Thank you for your enquiry. We will contact you within 24 hours.</div>
          </div>
        ) : (
          <Form
            form={form}
            name={'details'}
            initialValues={{remember: true}}
            onFinish={onFinish}
            className={'lg:w-96 px-2 py-4 rounded-xl'}
          >
            <Form.Item
              name={'username'}
              rules={[{required: true, message: 'Please enter your name'}]}
            >
              <Input
                className={'h-9 text-lg rounded-lg focus:border-primary-500 hover:border-primary-400 text-sm'}
                placeholder={'Name'}
              />
            </Form.Item>
            <Form.Item
              name={'email'}
              rules={[
                {required: true, message: 'Please enter your email'},
                {type: 'email', message: 'Invalid email'},
              ]}
            >
              <Input
                className={'h-9 text-lg rounded-lg focus:border-primary-500 hover:border-primary-400 text-sm'}
                placeholder={'Email'}
              />
            </Form.Item>
            <Form.Item
              name={'contact_no'}
              rules={[
                {required: true, message: 'Please enter your contact number'},
                {pattern: /^\d{10}$/, message: 'Invalid contact number. Please enter 10 digits.'},
              ]}
            >
              <Input
                type={'number'}
                className={'h-9 text-lg rounded-lg focus:border-primary-500 hover:border-primary-400 text-sm'}
                placeholder={'Contact Number'}
              />
            </Form.Item>
            <Form.Item name={'message'}>
              <TextArea
                placeholder={'Occasion details/ Message'}
                style={{height:'100px'}}
                className={'text-lg rounded-lg focus:border-primary-500 hover:border-primary-400 text-sm'}
              />
            </Form.Item>
            <Form.Item className={'text-center'}>
              <Button  htmlType={'submit'} className={'w-32 !bg-primary-900 !text-white'}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </div>
  );
};

export default GoldForm;
